module.exports = __webpack_public_path__ + "static/media/axegpromouse-3.56cabe30.jpg";